module.exports = __webpack_public_path__ + "img/project-cover7.64267c65.png";